/**
 * RelatedProducts.tsx — relaterte produkter (ibm.com «Related Products»)
 *
 * Kortrutenett: pictogram øverst, produktnavn nederst til venstre, pil nederst
 * til høyre. Hele kortet er en lenke. 1 kolonne (sm), 2 (md), 4 (lg).
 */

import Link from 'next/link';
import { ArrowRight } from '@carbon/icons-react';
import { LANDING_ICONS } from '@/components/landing/landing-icons';
import type { ProductRelated } from '@/types/product';
import SectionHeader from './SectionHeader';
import styles from './product.module.css';

export default function RelatedProducts({ related, id = 'relatert' }: { related: ProductRelated; id?: string }) {
  return (
    <section id={id} className={styles.section} aria-labelledby={`${id}-heading`}>
      <div className={styles.container}>
        <SectionHeader id={`${id}-heading`} eyebrow={related.eyebrow} heading={related.heading} />

        <ul className={styles.related} role="list">
          {related.items.map((item) => {
            const Icon = LANDING_ICONS[item.icon];
            return (
              <li key={item.href} className={styles.relatedItem}>
                <Link href={item.href} className={styles.relatedCard}>
                  <Icon className={styles.pictogramBlue} aria-hidden />
                  <span className={styles.relatedFoot}>
                    <span className={styles.relatedName}>{item.name}</span>
                    <ArrowRight size={20} aria-hidden className={styles.relatedArrow} />
                  </span>
                </Link>
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
}
